import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import MainApi from "../../../../../../services/mainApi.service";
import { IIntegrationRuleIServices } from "../../../../../../models/integration-rule-i-service";
import { memo, useMemo, useState } from "react";
import { IntegrationRuleIService } from "./IntegrationRuleIServiceForm/IntegrationRuleIService";

const checkRows = (
  rows: IIntegrationRuleIServices[],
  busAutomationCode: number | null,
) => {
  const matchIntegrationDirectionTypeCode = rows.some(
    (item) => item.integrationDirectionType.code === "3",
  );
  return (
    busAutomationCode === 5 &&
    (!matchIntegrationDirectionTypeCode || rows.length === 0)
  );
};

const INTEGRATION_RULE_I_SERVICE_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/4uBusIntegrationRuleIService/";
const integrationRuleIServiceService = new MainApi<IIntegrationRuleIServices>(
  INTEGRATION_RULE_I_SERVICE_ROUTE,
);

const translationPath = "page.4uBus.integrationRule.integrationRuleIService.";

export const IntegrationRuleIServicePage = memo(
  ({
    busAutomationCode,
    busAutomationId,
  }: {
    busAutomationCode: number | null;
    busAutomationId: string | null;
  }) => {
    const { id: busIntegrationRuleId } = useParams();

    const { t } = useTranslation();

    const [iServiceForm, setIServiceForm] = useState(false);

    const [selectedId, setSelectedId] = useState<string>();

    const [rows, setRows] = useState<IIntegrationRuleIServices[]>([]);

    const columns: GridColDef<IIntegrationRuleIServices>[] = [
      {
        field: "integrationDirectionType",
        headerName:
          t(translationPath + "integration_direction_type") ||
          "Integration Direction Type",
        renderCell: (params) => {
          if (!params.value) return "-";
          return (
            <OverflowTooltip
              text={params.value.name.toString()}
              tooltip={params.value.name.toString()}
              textTransform="none"
              variant="body2"
            />
          );
        },
      },
      {
        field: "iService",
        headerName: t(translationPath + "i_service") || "Service",
        renderCell: (params) => {
          if (!params.value) return "-";
          return (
            <OverflowTooltip
              text={params.value.name}
              tooltip={params.value.name}
              textTransform="none"
              variant="body2"
            />
          );
        },
      },
    ];

    const handleAdd = () => {
      setIServiceForm(true);
    };

    const handleRowClick = (
      params: GridRowParams<IIntegrationRuleIServices>,
    ) => {
      if (!params.row) return;
      setIServiceForm(true);
      setSelectedId(params.row.id);
    };

    const handleBack = () => {
      setSelectedId(undefined);
      setIServiceForm(false);
    };

    const params = useMemo(() => {
      return {
        _4uBusIntegrationRuleId: busIntegrationRuleId,
      };
    }, [busIntegrationRuleId]);

    const showGridWarning = checkRows(rows, busAutomationCode);

    return (
      <Box sx={{ height: 600, width: "100%" }}>
        {iServiceForm && (
          <Box
            sx={(t) => ({
              p: 1,
              px: 10,
              height: "100%",
              overflow: "auto",
              backgroundColor: t.palette.background.default,
              borderRadius: 1,
            })}
          >
            <IntegrationRuleIService
              id={selectedId}
              busIntegrationRuleId={busIntegrationRuleId}
              busAutomationCode={busAutomationCode}
              busAutomationId={busAutomationId}
              onBackButton={handleBack}
            />
          </Box>
        )}
        {!iServiceForm && (
          <Box height={600}>
            <Table<IIntegrationRuleIServices>
              showDefaultMacroFilters={false}
              headerAlertText={
                showGridWarning ? t(translationPath + "grid_warning") : null
              }
              service={integrationRuleIServiceService}
              serviceProps={params}
              onFetchData={(data) => {
                setRows(data);
              }}
              onFetchDelete={(data) => {
                const filterdRows = rows.filter((item) => item.id !== data?.id);
                setRows(filterdRows);
              }}
              columns={columns}
              title={t(translationPath + "integration_rule_i_services")}
              searchInput
              onAdd={handleAdd}
              onRowClick={handleRowClick}
              searchInputPlaceHolder={t(translationPath + "search")}
              addButtonLabel={
                t(translationPath + "add_integration_rule_i_service") ||
                "Add Integration Rule Service"
              }
              confirmOptions={{
                title: t(translationPath + "confirm.title"),
                description: t(translationPath + "confirm.description"),
                confirmationButtonProps: {
                  variant: "contained",
                },
              }}
            />
          </Box>
        )}
      </Box>
    );
  },
);
